var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"success","disabled":_vm.disabled || _vm.savePending || _vm.saved},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.savePending ? "Wird gespeichert" : (_vm.saved ? "Gespeichert" : "Speichern")))])}
var staticRenderFns = []

export { render, staticRenderFns }